(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* to be used in conjunction with a controller that is utilizing GroupUtils.startGroups
   to filter a detail page by group */
  directive('wsGroupFilter', ['wsConstants', '$location', 'GroupUtils', function wsGroupFilter(wsConstants, $location, GroupUtils) {
    return {
      scope: {
        groupInfo: "="
      },
      templateUrl: "modules/common/directives/group-filter/group-filter.html",
      link: function link(scope) {
        scope.changeSelected = function changeSelected(newGroup) {
          scope.groupInfo.selectedGroup = newGroup;
          if (scope.groupInfo.selectedGroup.isAll) {
            $location.url(GroupUtils.createGroupUrl($location.path()));
            return;
          }
          scope.groupInfo.groupId = scope.groupInfo.selectedGroup.id;
          $location.url(GroupUtils.createGroupUrl($location.path()) + "/" + scope.groupInfo.groupId);
        };

        //reset group filter to "all" when selection is removed
        scope.removeGroupSelection = function removeGroupSelection() {
          scope.changeSelected(wsConstants.allGroup);
        };
      }
    };
  }]);
})();
